// extracted by mini-css-extract-plugin
var _1 = "ActivityPageMobileFooter_actions__QxY62";
var _2 = "ActivityPageMobileFooter_footerDivider__W9YzH";
var _3 = "ActivityPageMobileFooter_mobileButtonsContainer__E5XFr";
export { _1 as "actions", _2 as "footerDivider", _3 as "mobileButtonsContainer" }
